
import React, { useEffect, useState } from "react";
import { isVerified, useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import { Alert, Box, Button, Snackbar, Stack, Typography } from "@mui/material";
import AsyncButton from "../common/AsyncButton";
import { InvokeAPI } from "../../apis/API";
import { getUserMgmtBase } from "../../config/apiBase";


const Verify = () => {
  const [loginData, setLoginData] = useState({
    username: '',
    password: '',
  });

  const { user, refreshUser } = useAuth()

  const handleLoginChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
  };

  const navigate = useNavigate();

  const [state, setState] = useState({ open: false, message: "" })

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const handleVerify = async e => {
    e.preventDefault();
    const username = loginData.username

    const resp = await InvokeAPI(`${getUserMgmtBase()}/v1/user/verify`,
      { "Code": username },
      'POST',
      { "authorization": user["token"] },
      false)
    
    if (resp.response["Status"] == true) {
      await refreshUser()
      navigate("/app")
    } else if (resp.rateLimitExceeded || (resp.errorMessage && resp.errorMessage.includes("Account verification retry limit reached"))) {
      setState({ open: true, message: "Account verification retry limit reached. Please try Resending Verification Code option." });
    } else {
      setState({ open: true, message: "Incorrect Verification Code entered" });
    }
  };

  const resendVerificationCode = async e => {
    e.preventDefault();

    const resp = await InvokeAPI(`${getUserMgmtBase()}/v1/user/verify/send`,
      {},
      'POST',
      { "authorization": user["token"] },
      false)

    if (resp.rateLimitExceeded || (resp.errorMessage && resp.errorMessage.includes("Resending Verification Code limit reached"))) {
      setState({ open: true, message: "Resending Verification Code limit reached. Please try after 24 hrs." });
    } else if (resp.iserror) {
      setState({ open: true, message: "Internal error please try again or send email to administrator." });
    } else {
      setState({ open: true, message: "Verification code has been resent to your email address." });
    }
  };

  return (
    <>


      {isVerified() ? <>
        <Box display="flex" justifyContent="center" alignItems="center">
          <Stack>
          Your account is verified, click Continue to use the platform!
          
          <Button type="submit" variant="contained" color="primary" sx={{marginTop: '20px'}} onClick={() => navigate("/app")}>
            Continue
          </Button>
          </Stack>
        </Box>
      </>
        : <>
          <form>
            <Snackbar
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              open={state.open}
              onClose={handleClose}
              key={state.message}
              sx={{
                zIndex: (theme) => theme.zIndex.drawer + 2,
                top: { xs: 72, sm: 80 },
              }}
            >
              <Alert variant="filled" severity="error">
                {state.message}
              </Alert>
            </Snackbar>
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
              <h2>Enter code to verify!</h2>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1, textAlign: 'center' }}>
                A verification code has been sent to the email address you used during sign up.
              </Typography>
            </Box>
            <TextField
              label="Verification Code"
              variant="outlined"
              fullWidth
              name="username"
              value={loginData.username}
              onChange={handleLoginChange}
              required
            />
            <p></p>
            <Box display="flex" justifyContent="center" alignItems="center">
              <AsyncButton type="submit" variant="contained" color="primary" onClick={handleVerify}>
                Verify
              </AsyncButton>
            </Box>
          </form>
          <p></p>
          <Box display="flex" justifyContent="center" alignItems="center">
            <AsyncButton sx={{ textTransform: "initial" }} type="link" color="primary" onClick={resendVerificationCode} loadingLabel="Resending...">
              Resend Verification Code
            </AsyncButton>
          </Box>
        </>
      }

    </>
  );
};

export default Verify;
